import {
  RESET_EXPERT_TYPING,
  SET_EXPERTS,
  SET_EXPERT_TYPING,
  SET_EXPERT_STATUS,
  RESET_EXPERT,
  SET_IS_CALL_NEW_EXPERT_BUTTON_DISABLED,
  SET_CHANGE_EXPERT_REASONS,
} from '../actions/experts';
import { SET_NEW_MESSAGE } from '../actions/messages';

export const expertsInitialState = {
  mode: null,
  list: null,
  activeExpert: null,
  savedExperts: [],
  typingExperts: [],
  onlineExperts: [],
  changeExpertReasons: [],
  isNewExpertButtonDisabled: true,
};

export default (state = expertsInitialState, { type, result, payload }) => {
  switch (type) {
    case SET_EXPERTS:
      
      const list = result && result.experts;
      const mode = result && result.mode;
      let activeExpert;
      const currentExpertSaved = state.savedExperts.length && state.savedExperts.find((exp) => exp.expertId === payload);

      if (currentExpertSaved) {
        activeExpert = currentExpertSaved;
      } else {
        activeExpert = (result && result.expert) || (result && result.experts && state.activeExpert) || { expertId: payload };
      }
      if (result && (result.experts || result.expert)) {
        let stateExpertsSet;
        if (result.experts) {
          stateExpertsSet = new Set([...state.savedExperts, ...result.experts]);
        } else if (result.expert) {
          stateExpertsSet = new Set([...state.savedExperts, result.expert]);
        }
        
        let stateExperts = Array.from(stateExpertsSet);

        return {
          ...state,
          savedExperts: stateExperts,
          list,
          activeExpert,
          mode,
          isNewExpertButtonDisabled: false,
        };
      }

      if (payload) {
        return {
          ...state,
          list,
          activeExpert,
          mode,
          isNewExpertButtonDisabled: false,
        };
      }

      return {
        ...state,
        list,
        activeExpert,
        mode,
      };

    case SET_EXPERT_TYPING: {
      const { isTyping, sender } = result;

      return {
        ...state,
        typingExperts: [
          ...state.typingExperts.filter((expert) => expert.senderId !== sender.sender_id),
          {
            name: sender.name,
            typeId: sender.type_id,
            senderId: sender.sender_id,
            expertId: sender.expert_id,
            avatarUrl: sender.picture_path,
            isTyping,
          },
        ],
      };
    }

    case SET_NEW_MESSAGE: {
      const message =
        result.message_id || result.message_uuid
          ? result
          : result.data && result.data.message
            ? result.data.message
            : {};
      const senderId = message && message.sender && message.sender.sender_id;

      return {
        ...state,
        typingExperts: state.typingExperts.filter((expert) => expert.senderId !== senderId),
      };
    }

    case RESET_EXPERT_TYPING: {
      return {
        ...state,
        typingExperts: state.typingExperts.filter((expert) => expert.senderId !== payload),
      };
    }

    case RESET_EXPERT: {
      return {
        ...state,
        activeExpert: null,
      };
    }

    case SET_IS_CALL_NEW_EXPERT_BUTTON_DISABLED:
      return { ...state, isNewExpertButtonDisabled: payload };

    case SET_EXPERT_STATUS: {
      return {
        ...state,
        onlineExperts: [
          ...state.onlineExperts.filter((expert) => expert.expertId !== result.expertId),
          {
            expertId: result.expertId,
            isOnline: result.isOnline,
            senderId: result.senderId
          },
        ],
      };
    }

    case SET_CHANGE_EXPERT_REASONS: {
      return {
        ...state,
        changeExpertReasons: result && result.data && result.data.expertChangeReasons,
      };
    }

    default:
      return state;
  }
};
